import {
  BottomSheetContainer,
  Colors,
  createUseBottomSheetModal,
  Flex,
  IconCheck,
  Typography,
  VerticalSpacing,
} from '@banhala/ui-kit';
import type { SortingItem } from './types';

export const useSortingBottomSheet = createUseBottomSheetModal<
  { selectedItem: SortingItem },
  { selectedText: string; possibleItems: SortingItem[] }
>(({ confirm, param }) => {
  return (
    <BottomSheetContainer>
      <VerticalSpacing size={16} />
      {param.possibleItems.map(item => {
        const isSelected = item.text === param.selectedText;
        return (
          <Flex.Row
            key={item.query_value}
            alignItems="center"
            justifyContent="space-between"
            padding={{ horizontal: 16, vertical: 16 }}
            onPress={() => confirm({ selectedItem: item })}
          >
            <Typography
              type={isSelected ? 'subtitle1' : 'body1'}
              color={isSelected ? 'content_pink_primary' : undefined}
            >
              {item.text}
            </Typography>
            {isSelected ? (
              <IconCheck size={20} fill={Colors.content_pink_primary} />
            ) : (
              <></>
            )}
          </Flex.Row>
        );
      })}
    </BottomSheetContainer>
  );
});
